var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMda = function SvgMda(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.326H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M330.207 85.331H512v341.337H330.207z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.331h181.793v341.337H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9811",
    d: "M315.362 219.607H274.55c0-10.244-8.306-18.551-18.551-18.551-10.246 0-18.551 8.306-18.551 18.551h-40.812c0 10.088 8.787 18.265 18.874 18.265h-.608c0 10.088 8.176 18.266 18.265 18.266 0 8.931 6.414 16.353 14.886 17.939l-14.393 32.495c6.896 2.804 14.434 4.362 22.338 4.362s15.441-1.558 22.338-4.362l-14.392-32.495c8.471-1.586 14.886-9.008 14.886-17.939 10.089 0 18.265-8.179 18.265-18.266h-.609c10.09-.001 18.876-8.179 18.876-18.265z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M256 244.864l-24.116 11.13v22.261L256 293.095l24.116-14.84v-22.261z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M231.88 233.734h48.228v22.261H231.88z"
  })));
};
export { SvgMda as ReactComponent };